import getApiRoot from '../utils/getApiRoot';

const getTermsAndConditionsLink = async () =>
  `${await getApiRoot()}/public/company/terms-and-conditions/web`;

export default getTermsAndConditionsLink;
